export default "__VITE_ASSET__cb28c3d7__"